// Add the split feature flags for A/B test in the enum object
// for example: RDP375 = RDP-375_FeaturedAgencies_BackgroundColor, RDP375 is the split name that creating on split.io, only when at least one split exists will send the request to split.io
// Can't be deleted
export enum SplitFeatureFlags {}
// No active feature flags currently
